import React from "react";
import { withTranslation } from 'react-i18next';
import i18n from '../../../i18n';
import configData from '../../../config/config.json';
import queryString from 'query-string';
import { addLangParam } from '../../../utils/apiHelpers';
import { withStyles } from '@material-ui/core/styles';
import { Button, Stepper, StepButton, StepLabel, Step } from '@material-ui/core';

import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import { NightsStay, SearchOutlined as SearchIcon} from "@material-ui/icons";
import { FilterListOutlined as FilterList} from "@material-ui/icons";
import { FlightTakeoff as FlightIcon } from "@material-ui/icons";
import { EventAvailable as CalendarIconOneColor } from "@material-ui/icons";
import { Star } from "@material-ui/icons";
import Pax from '../Pax';
import MuiAlert from '@material-ui/lab/Alert';
import Alert from '@material-ui/lab/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';

// Load external SVG files as icons
import { ReactComponent as FamilyRestroomIcon} from '../../../assets/images/icons/FamilyRestroomIcon.svg';
import { ReactComponent as CalendarIcon} from '../../../assets/images/icons/calendar.svg';

// Holiday icons

// NOTEICE: These icons are no longer inlined! they are loaded dynamically by the DB!

/*import { ReactComponent as RoshHashanaIcon} from '../../images/icons/rosh-hashana.svg';
import { ReactComponent as YomKipurIcon} from '../../images/icons/yom-kipur.svg';
import { ReactComponent as SukkotIcon} from '../../images/icons/sukkot.svg';
import { ReactComponent as ChristmasIcon} from '../../images/icons/christmas.svg';
import { ReactComponent as ChristmasSalesIcon} from '../../images/icons/christmas.svg';
import { ReactComponent as HanukkaIcon} from '../../images/icons/hanukkah.svg';
import { ReactComponent as PurimIcon} from '../../images/icons/purim.svg';
import { ReactComponent as PassoverIcon} from '../../images/icons/passover.svg';
import { ReactComponent as IndependenseDayIcon} from '../../images/icons/independence-day.svg';
import { ReactComponent as SabboseIcon} from '../../images/icons/sabbose.svg';
import { ReactComponent as SummerVacationIcon} from '../../images/icons/summer-vacation.svg';
*/
// buttons
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

//import NotificationIcon from '@material-ui/icons/NotificationImportant';
import WbIncandescentIcon from '@material-ui/icons/WbIncandescent';
import Typography from '@material-ui/core/Typography';

import CircularProgress from '@material-ui/core/CircularProgress';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';

import PeopleIcon from '@material-ui/icons/People';
import Switch from '@material-ui/core/Switch';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Checkbox from '@material-ui/core/Checkbox';
import Divider from "@material-ui/core/Divider";
import FormControlLabel from "@material-ui/core/FormControlLabel";
//import CommentIcon from '@material-ui/icons/Comment';

import './index.css';

import Calendar from '../../Calendar'

const API_ENDPOINT = configData.API_ENDPOINT;

// NUMBER OF MONTHS TO SHOW AHEAD
const startMonth = configData.CALENDAR?.start_month;
const endMonth   = configData.CALENDAR?.end_month;
//const nMonths = configData.CALENDAR.months_count; // date in N months from today (last day of that month)      
const skipMonthsArray = configData?.CALENDAR?.skip_months; // date in N months from today (last day of that month)      

// Calculate the start date either by using the provided start date or by subtracting the months count from the endDate
let dt = new Date();
let minDate = new Date(dt.getTime() + 1 * 24 * 60 * 60 * 1000); // date in 24 hours

if (startMonth && minDate.getTime() <= new Date(startMonth.split('-')[0], startMonth.split('-')[1] - 1, 1).getTime()) {
    minDate = new Date(startMonth.split('-')[0], startMonth.split('-')[1] - 1, 1);
    //startMonth = dt.getFullYear() + '-' + (dt.getMonth() + 1);
}

// Calculate the end date either by using the provided end date or by adding the months count to the startDate
const endDate = new Date(endMonth.split('-')[0], endMonth.split('-')[1], 1); // INPUT: YYYY-MM

// set maxDate as the date of the last day of the endDate given month
let maxDate = new Date(endDate.getFullYear(), endDate.getMonth(), 0); // 0=set date to the last day of month in nMonths months (7)

// Calculate the number of months we'll show
const nMonths = Math.round((endDate.getTime() - minDate.getTime())  / (1000 * 60 * 60 * 24 * 30));

// Fetch the list of months names & years
const monthsArray = getNextNMonthNamesWithYear(minDate, maxDate, skipMonthsArray); // Get total of 6 months

 // Calculate the number of cells per row
let cellsPerRow = 3;
if ((monthsArray.length >= 6 && monthsArray.length < 8) || monthsArray.length > 8) 
    cellsPerRow = 4;


const DialogContent = withStyles((theme) => ({
    root: {
      padding: theme.spacing(2),
    },
}))(MuiDialogContent);
  
const DialogActions = withStyles((theme) => ({
    root: {
      margin: 0,
      padding: theme.spacing(1),
    },
}))(MuiDialogActions);

  
  


class SearchWizard extends React.Component {
        
    constructor (props) {
        super(props)

        if (!this.props.location || !this.props.location.search || this.props?.location?.search==="") {
            console.log('default')
            this.state = {
                filters : {
                    ...this.props.filters,
                    window: {
                        ...this.props.filters.window,
                        'step': 0,
                        'next_step_close': this.props?.filters?.window?.next_step_close?this.props?.filters?.window?.next_step_close:false,
                        'dates_error': false,
                        'dates_not_allowed': false,
                        'visible': this.props?.is_open,
                    },
                },
                calendar: false
            }
        }
        else if (this.props.location.search) {
            //console.log('else')
            const QS = queryString.parse(this.props.location.search);

            if (QS?.when!='dates') {
                delete(QS['from']);
                delete(QS['to']);
            }
            this.state = {
                rooms: [
                    {
                        adults: [30,30],
                        teens: [],
                        children: [],
                        infants: []
                    }
                ],
                filters : {
                    ...this.props.filters,
                    window: {
                        ...this.props.filters.window,
                        'step': 0,
                        'next_step_close': this.props?.filters?.window?.next_step_close?this.props?.filters?.window?.next_step_close:false,
                        'visible': this.props.is_open
                    },
                    QS
                    //QS.when!=undefined?'when':QS.when:''
                },
            }
        } else {
            this.state = {
                //all_destinations: (this.props.destinations)
            }
        }

        
        if (this.props.type==="flights") 
            this.HideDealFilter = ' hide ';

    }
    
    componentDidMount() {
        // Monitor scrolling to show filters after 3rd result
        document.addEventListener('scroll', this.handleScroll);
    }


    handleScroll = event => {
 
        try {
            if (!(document.getElementsByClassName('filters_toggle')) || !(document.getElementsByClassName('filters_toggle').length > 0))
                return

            //var card_lines = document.getElementsByClassName('card');
            var filters_button = document.getElementById('searchWizardButtons')
            var filters_rect = filters_button?.getBoundingClientRect();

            if (filters_rect?.bottom < 0)
                document.getElementsByClassName('filters_toggle')[0].className='filters_toggle float visible'
            else 
                document.getElementsByClassName('filters_toggle')[0].className='filters_toggle hidden'
        } catch(e) {}   
    }

   
    render(){
        const { t, i18n } = this.props;
        const currentLang = i18n.language; // 'he', 'en', etc.
        //console.log('rendered search box')

        // Generate dates caption
        let when_caption = t('search.captions.when.allDates');
        let dates_caption = when_caption;

        if (this.props.filters.months && this.props.filters.months?.length>0) {
            if (this.props.filters.months.length>1) {
                when_caption = t('search.captions.when.selectedMonths')
            } else {
                when_caption = t('search.captions.when.selectedMonth')
            }
        }

        if (this.props.filters.from_date && this.props.filters.to_date) {
            when_caption = t('search.captions.when.selectedDates')

            const from = this.props.filters.from_date;
            const to = this.props.filters.to_date;

            // fixed according to this suggestions: https://stackoverflow.com/questions/61218243/javascript-returns-nan-only-in-ios-browsers
            const fromDate = new Date(from.split('-')[0],from.split('-')[1]-1,from.split('-')[2]);
            const toDate = new Date(to.split('-')[0],to.split('-')[1]-1,to.split('-')[2]);

          // todo: fix iphone bug showing this as NaN/NaN/NaN...
            when_caption =  (fromDate.getDate() + "/" + (fromDate.getMonth()*1+1) + '/' + (toDate.getFullYear()+'').replace('20','') + t('filters.dateRange.to') + (toDate.getDate() + "/" + (toDate.getMonth()*1+1)) + '/' + (toDate.getFullYear()+'').replace('20',''))
            dates_caption = when_caption
        }

        if (this.props.filters.holidays && this.props.filters.holidays.length > 0) {
            when_caption = t('search.captions.when.selectedHolidays')
        }


        // Prepare Stars Caption
        let stars_caption = t('search.captions.stars.threeToFive')

        if (this.props.filters.stars && this.props.filters?.stars.length > 0 ) {
            const stars = this.props.filters.stars;
            if (stars.find(star=>star==='3')) {
                if (!stars.find(star=>star=='4') && !stars.find(star=>star=='5')) {
                    stars_caption = t('search.captions.stars.threeStars')
                } else {
                    if (stars.find(star=>star==='4')) {
                        if (stars.find(star=>star==='5')) {
                            stars_caption = t('search.captions.stars.threeToFive')
                        } else {
                            stars_caption = t('search.captions.stars.threeToFour')
                        }
                    }
                    if (stars.find(star=>star==='5')) {
                        if (stars.find(star=>star==='4')) {
                            stars_caption = t('search.captions.stars.threeToFive')
                        } else {
                            stars_caption = t('search.captions.stars.threeOrFive')
                        }
                    }
                }
            } else {
                if (stars.find(star=>star==='4')) {
                    if (stars.find(star=>star==='5')) {
                        stars_caption = t('search.captions.stars.fourToFive')
                    } else {
                        stars_caption = t('search.captions.stars.fourStars')
                    }
                } else {
                    stars_caption = t('search.captions.stars.fiveStars')
                }
            }
        }

        // Prepare nights caption
        let nights_caption = t('search.captions.nights.threeToSeven')
        if (this.props.filters.nights && this.props.filters?.nights.length > 0 ) {
            const nights = this.props.filters.nights;
            if (nights.length==1) {
                nights_caption = t('search.captions.nights.specific', { count: nights[0] })
            } else {
                const min_nights = Math.min( ...nights );
                const max_nights = Math.max( ...nights );
                nights_caption = t('search.captions.nights.range', { min: min_nights, max: max_nights })
            }
        }

        // Prepare destinations caption
        let destinations_caption = t('search.captions.destinations.all');
        //console.log(this.props.filters?.destinations)
        if (this.props.filters.destinations && this.props.filters.destinations!='' && this.props.filters.destinations?.length>0) {
            if ((Array.isArray(this.props.filters.destinations)&&this.props.filters?.destinations?.length>1 ) ||(!Array.isArray(this.props.filters.destinations) && this.props.filters?.destinations?.split(',').length>1)) {
                destinations_caption = t('search.captions.destinations.selectedMultiple', { count: (Array.isArray(this.props.filters.destinations)?this.props.filters.destinations.length:this.props.filters.destinations.split(',').length) })
            } else {
                destinations_caption = t('search.captions.destinations.selectedSingle')
            }
        }



            
        //const { open } = this.state;
        // Convert sql date format to native date that also supported by Iphone
        //const from_date = this.state.filters.from_date?new Date(this.state.filters.from_date):null;
        //console.log(from_date)
        /*const from = !from_date?
                        null:
                        from_date//new Date(from_date.split('-')[0],from_date.split('-')[1]-1,from_date.split('-')[2]);
        const to_date = this.state.filters.to_date?new Date(this.state.filters.to_date):null;
        const to = !to_date?
                        null:
                        to_date//new Date(to_date.split('-')[0],to_date.split('-')[1]-1,to_date.split('-')[2]);
          */      

        const location = this.props.location;
        this.querystring = "";
        /*if (this.state.filters)
            Object.keys(this.state.filters).map(i => this.querystring+=`&${i}=${this.state.filters[i]}` )
        this.filter_path = location.pathname + "?" +  this.querystring;*/
      
        
        //if (this.state.redirect) {

            
        //}


        
        //const fromArray = this.state.filters?.from?.split("/");
        //const fromDate = fromArray&&fromArray.length>1?(fromArray[2].substr(0, 2) + '/' + fromArray[1] + '/' + fromArray[0]):null;

        //const toArray = this.state.filters?.to?.split("/");
        //const toDate = toArray&&toArray.length>1?(toArray[2].substr(0, 2) + '/' + toArray[1] + '/' +  toArray[0]):null;

        /*let destinations = this.props?.destinations?.map((dest) => 
            <option 
                value={dest.city_id}
                key  ={dest.city_uid}
            >
                {dest.city_name}
            </option>
        )*/

        
        // If we're at step 0 then fetch all holidays once
        try {

            if ((this.props.is_open) && !this.state?.all_holidays) {
                const baseUrl = `${API_ENDPOINT}/search/holidays/?filters=true`;
                const url = addLangParam(baseUrl);
                //console.log(url)
                fetch(url)
                    .then(response => {
                        if (response.ok) {
                            return response.json()
                        } else {
                            throw new Error(this.props.t('common.errors.network.error303'));
                        }
                    })
                    .then(response=>{
                        return response.sort((a,b) => {
                            if (a.start_date > b.start_date) {
                                return 1;
                            }
                            if (b.start_date > a.start_date) {
                                return -1;
                            }
                            return 0;
                        }
                    )})
                    .then(response=>{
                        this.setState(prevState=>({
                            ...prevState,
                            all_holidays: response.slice(0, 4) // get only 4 first results
                        }))
                    })
            }    
        } catch (e) {
            console.log('Failed to load holidays list')
            console.log(e)
        }
        
        // If we're at step 1 and the list of destinations is empty, then fetch it from the server
        if (this.props.step == 4 && !this.props?.all_destinations) {
            const baseUrl = `${API_ENDPOINT}/search/destinations/`;
            const url = addLangParam(baseUrl);
            fetch(url)
                .then(response => {
                    if (response.ok) {
                        return response.json()
                    } else {
                        throw new Error(this.props.t('common.errors.network.error303'));
                    }
                })
                .then(response=>{
                    return response.sort((a,b) => {
                        if (a.city_name > b.city_name) {
                            return 1;
                        }
                        if (b.city_name > a.city_name) {
                            return -1;
                        }
                        return 0;
                    }
                )}).then(response=>{
                    this.setState(prevState=>({
                        ...prevState,
                        all_destinations: response
                    }))
                })
        }

        return (
        <>
            <div className="filters_toggle hidden "
                style={{position:'fixed',zIndex:1000,width:'100%', bottom: 0, borderRadius: 0, fontSize:'1.4em', padding:'.25em', fontWeight:800}}
                onClick={e=>{this.handleToggleFilters(e, 0)}}>
                <SearchIcon style={{
                    fontSize:'1.5em',
                    margin:'0 .25em',
                    fontWeight:800,
                    strokeWidth: 1,
                    stroke: '#222'
                }} />
                {t('search.clickToSearch')}</div>
            <div className={'searchWizardButtons mobile hidden'+(this.props?.hidden?' hidden ':'')} id="searchWizardButtons">
                <div>        
                    <Button
                        className="searchWizardOpenButton"
                        variant='contained'
                        color='primary'
                        onClick={e=>{this.handleToggleFilters(e, 0)}}
                        startIcon={<SearchIcon />}
                       >{t('search.searchDeals')}
                    </Button>
                </div>
                {/*<Modal open={open} onClose={this.onCloseModal} style={{margin:0, width:'85%',float:'left',height:'inherit'}}>*/}
                <div>
                    <Button
                        className="searchWizardDestinationsButton"
                        variant='contained'
                        color='primary'
                        onClick={e=>{this.handleToggleFilters(e, 3, false)}}
                        startIcon={<FilterList />}
                       >{t('search.filterDestinations')}
                    </Button>
                    {/*<select name="sortBy" value={this.state.filters.sortby} className="sort"
                        onClick={e=>{this.handleToggleFilters(e, 2, false)}}
                        >
                        <option>{t('search.filterDestinations')}</option>
                    </select>*/}
                </div>
            </div>

            <div className="searchWizardButtons" style={{display:'none'}}>

                <div className="searchWizardOptionButtonWrapper">
                    <div className="label">{t('search.steps.when.label')}</div>
                    <Button
                        className="searchWizardOptionButton"
                        variant='contained'
                        color='primary'
                        onClick={e=>{this.handleToggleFilters(e, 1, true)}}
                        startIcon={<CalendarIconOneColor />}
                       >{when_caption}
                    </Button>
                </div>

                <div className={`searchWizardOptionButtonWrapper ` + ((this.props.filters?.dates_type==='exact'/*||this.state.filters?.holidays?.length>0*/)?'hidden':'')}>
                    <div className="label">{t('search.steps.duration.title')}</div>
                    <Button
                        className="searchWizardOptionButton"
                        variant='contained'
                        color='primary'
                        onClick={e=>{this.handleToggleFilters(e, 2, true)}}
                        startIcon={<NightsStay />}
                       >{nights_caption}
                    </Button>
                </div>

                <div className="searchWizardOptionButtonWrapper">
                    <div className="label">{t('search.steps.hotelLevel.question')}</div>
                    <Button
                        className="searchWizardOptionButton"
                        variant='contained'
                        color='primary'
                        onClick={e=>{this.handleToggleFilters(e, 3, true)}}
                        startIcon={<Star />}
                       >{stars_caption}
                    </Button>
                </div>

                <div className="searchWizardOptionButtonWrapper">
                    <div className="label">{t('search.steps.destination.label')}</div>
                    <Button
                        className="searchWizardOptionButton flight"
                        variant='contained'
                        color='primary'
                        onClick={e=>{this.handleToggleFilters(e, 4, true)}}
                        startIcon={<FlightIcon />}
                       >{destinations_caption}
                    </Button>
                </div>

                <div className="searchWizardOptionButtonWrapper ">
                    <div className="label">&nbsp;</div>
                    <Button
                        className={this.props.blinkButton?'searchWizardOptionButton submit blinkButton':'searchWizardOptionButton submit'}
                        variant='contained'
                        color='primary'
                        onClick={e=>{this.props.handleSubmit(e, 'desktop')}}
                       >{t('search.findCheapVacation')}
                    </Button>
                </div>

            </div>
            
            <Calendar 
                open={this.props?.calendar?true:false} 
                range={this.props.filters?.dates} 
                dates_type={this.props.filters?.dates_type} 
                sendCalendarData={this.props.handleCalendarChange} 
                onCloseCalendar={this.props.handleCloseCalendar}>
            </Calendar>
           
            <Dialog 
                fullScreen 
                open={this.props.open}  
                onClose={e=>{this.props.handleClose(e)}} 
                scroll="paper"
                id="search_wizard"
                style={{zIndex:99999999}}> 
                <AppBar className="search-wizard-appbar">
                    <Toolbar className="search-wizard-toolbar" tabIndex={0}>
                        <IconButton edge="start" color="inherit" onClick={e=>{this.props.handleClose(e)}} aria-label="close">
                            <CloseIcon />
                        </IconButton>
                        <Typography variant="h5" style={{flex: 1}}>
                            {t('search.title')}
                        </Typography>
                        <Box component="span" m={2}></Box>
                    </Toolbar>

                    <Stepper 
                          
                        activeStep={
                            this.props?.step && this.props?.step*1>0 ?
                                this.props?.step*1:
                                0
                            } 
                            className={this.props.step=='4'?'hidden':''} >
                        
                        <Step key={0} title={t('search.stepTitles.step1')}      onClick={e=>this.props.gotoStep(e,'0')}>
                            <StepButton></StepButton>
                        </Step>
                    
                        <Step key={1} title={t('search.stepTitles.step2')}       onClick={e=>this.props.gotoStep(e,'1')}>
                            <StepButton></StepButton>
                        </Step>
                        <Step key={2} title={t('search.stepTitles.step3')}         onClick={e=>this.props.gotoStep(e,'2')}>
                            <StepButton></StepButton>
                        </Step>
                        <Step key={3} title={t('search.stepTitles.step4')} onClick={e=>this.props.gotoStep(e,'3')}>
                            <StepButton ></StepButton>
                        </Step>                                   
                    </Stepper>
                </AppBar>
                <DialogContent className="search-wizard-dialog-content">
                    <div className='window'>
                        <a name="step1"></a>
                        <div className={this.props?.step==='0'?'step1':'hidden'} id='step1'>
                            <Pax 
                                filters={this.props.filters}
                                open={this.props?.step==='0'}
                                ModifyAdults={this.props.ModifyAdults}
                                ModifyChildren={this.props.ModifyChildren}
                                ModifyInfants={this.props.ModifyInfants}
                                ModifyTeens={this.props.ModifyTeens}
                            ></Pax>
                        </div>

                        <a name="step2"></a>
                        <div className={this.props?.step==='1'?'step2':'hidden'} id='step2' role="group" aria-label={t('search.steps.when.ariaLabel')} >
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <h1 tabIndex={0}>{t('search.steps.when.question')}</h1> 
                                    
                                    <div className='notification'  tabIndex={0}>
                                        <WbIncandescentIcon 
                                            className='icon'
                                        />{t('search.steps.when.tip')}
                                    </div>


                                </Grid>

                                <Grid item  xs={cellsPerRow===4?3:4} sm={cellsPerRow===4?3:4}>
                                <Button
                                    className="searchToggleButton"
                                    variant={(this.props.filters?.months?.length==0&&this.props?.filters?.holidays?.length==0&&!this.props?.filters?.from_date)?'contained':'outlined'}
                                    color='primary'
                                    onClick={e=>this.props.toggleMonth('all')}
                                    style={{fontWeight:800}}
                                >{t('search.steps.when.allYear')}
                                </Button>
                                </Grid>
                                {
                                    monthsArray.map((month,index)=>{
                                        return (
                                            <Grid item  xs={cellsPerRow===4?3:4} sm={cellsPerRow===4?3:4} key={month+index}>
                                                <Button
                                                    className="searchToggleButton"
                                                    variant={(this.props.filters?.months?.find(item=>item===month?.value)?'contained':'outlined')}
                                                    color='primary'
                                                    onClick={e=>this.props.toggleMonth(month?.value)}
                                                    disabled={!month.name}
                                                >
                                                    <strong>{month?.name?.split(' ')[0]}</strong>{month?.name?.split(' ')[1]}
                                                    {month?.year}
                                                </Button>
                                            </Grid>
                                        )}
                                    )
                                }
                            </Grid>
                            <Grid container spacing={2}  className='mt-1'>
                                {this.state?.all_holidays?.map((holiday,index)=>{
                                    return holiday.holidays_translations.name ? (
                                        <Grid item xs={6} key={holiday+index}>
                                            <Button
                                                className="searchToggleButton dates"
                                                variant={this.props.filters?.holidays.find(item=>item===holiday?.uid)?'contained':'outlined'}
                                                color='primary'
                                                onClick={e=>this.props.toggleHoliday(holiday.uid,holiday.holidays_translations.name, holiday.start_date, holiday.end_date)} 
                                                startIcon={<img src={`${require('../../../assets/images/icons/'+holiday.uid+'.svg')}`} alt='' />}
                                            >
                                                <Grid container>
                                                    <Grid item xs={12}>
                                                        <strong>{holiday.holidays_translations.name} </strong> 
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        {holiday?.start_date?.split('-')[0]}
                                                    </Grid>
                                                </Grid>
                                            </Button>
                                        </Grid>
                                    ) : null
                                })}                                

                                <Grid item xs={12} className="search-calendar-button-wrapper">
                                    <Button
                                        className="searchToggleButton dates calendar"
                                        variant={this.props.filters?.from_date!='' &&  (!this.props.filters?.holidays||this.props.filters?.holidays=='')?'contained':'outlined'}
                                        color='primary'
                                        onClick={e=>this.props.toggleCalendar(e)} 
                                        startIcon={<CalendarIcon />}
                                    >
                                        <Grid>
                                            <Grid item xs={12} style={{fontWeight:800,fontSize:'1.1em'}}><strong>{this.props.filters?.from_date && (!this.props.filters?.holidays||this.props.filters?.holidays=='')?dates_caption:t('search.steps.when.selectDates')}</strong></Grid>
                                        </Grid>
                                    </Button>
                                </Grid>
                            </Grid>
                        </div>

                        <a name="step3"></a>
                        <div className={this.props?.step==='2'?'step3':'hidden'} id='step3'>


                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <h1>​{t('search.steps.hotelLevel.title')}​</h1> 
                                    {t('search.steps.hotelLevel.subtitle')}
                                </Grid>

                                <Grid item xs sm={3}>
                                <Button
                                    className="searchToggleButton pax"
                                    variant={(this.props?.filters?.stars.length==0?'contained':'outlined')}
                                    color='primary'
                                    onClick={e=>this.props.toggleStars('all')}
                                    style={{padding:'.5em', fontWeight: 800}}
                                >
                                    <span style={{fontSize:'.8em'}}>​{t('search.steps.hotelLevel.noPreference')}​</span>
                                </Button>
                                </Grid>

                                <Grid item xs sm={3}>
                                <Button
                                    className="searchToggleButton"
                                    variant={(this.props?.filters?.stars.find(star=>star==='3')?'contained':'outlined')}
                                    style={{padding:'.5em'}}
                                    color='primary'
                                    onClick={e=>this.props.toggleStars('3')}
                                    title={t('filters.stars.threeStarsTitle')}
                                >
                                    <span style={{color:'#b39300',fontSize:'1.1em'}}>★★★</span>
                                    <span style={{fontSize:'.8em'}}>​{t('filters.stars.threeStarsLabel')}​</span>
                                </Button>
                                </Grid>

                                <Grid item xs sm={3}>
                                <Button
                                    className="searchToggleButton"
                                    variant={(this.props?.filters?.stars.find(star=>star==='4')?'contained':'outlined')}
                                    color='primary'
                                    onClick={e=>this.props.toggleStars('4')}
                                    style={{padding:'.5em'}}
                                    title={t('filters.stars.fourStarsTitle')}
                                >
                                    <span style={{color:'#b39300',fontSize:'1.1em'}}>★★★★</span>
                                    <span style={{fontSize:'.8em'}}>​{t('filters.stars.fourStarsLabel')}​</span>
                                </Button>
                                </Grid>

                                <Grid item xs sm={3}>
                                <Button
                                title={t('filters.stars.fiveStarsTitle')}
                                    className="searchToggleButton"
                                    variant={(this.props?.filters?.stars.find(star=>star==='5')?'contained':'outlined')}
                                    color='primary'
                                    onClick={e=>this.props.toggleStars('5')}
                                    style={{padding:'.5em'}}
                                >
                                    <span style={{color:'#b39300',fontSize:'1.1em'}}>★★★★★</span>
                                    <span style={{fontSize:'.8em'}}>​{t('filters.stars.fiveStarsLabel')}​</span>
                                </Button>
                                </Grid>
                            </Grid>

                            <Box m={2}></Box>

                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <h1>​{t('search.steps.meals.title')}​</h1> 
                                    {t('search.steps.meals.subtitle')}
                                </Grid>

                                <Grid item  xs={4}>
                                <Button
                                    className="searchToggleButton"
                                    variant={(this.props.filters?.meals.length==0?'contained':'outlined')}
                                    color='primary'
                                    onClick={e=>this.props.toggleMealCode('all')}
                                    style={{fontWeight:800}}
                                >{t('search.steps.meals.noPreference')}
                                </Button>
                                </Grid>

                                {/*<Grid item  xs={4}>
                                <Button
                                    className="searchToggleButton"
                                    variant={(this.props.filters.meals.find(meal=>meal==='RO')?'contained':'outlined')}
                                    color='primary'
                                    onClick={e=>this.toggleMealCode('RO')}
                                >
                                    {t('filters.meals.roomOnly')}
                                </Button>
                                </Grid>*/}

                                <Grid item  xs={4}>
                                <Button
                                    className="searchToggleButton"
                                    variant={(this.props.filters.meals.find(meal=>meal==='BB')?'contained':'outlined')}
                                    color='primary'
                                    onClick={e=>this.props.toggleMealCode('BB')}
                                >
                                    <strong>​{t('search.steps.meals.breakfast')}​</strong>
                                </Button>
                                </Grid>
{/* 
                                <Grid item  xs={4}>
                                <Button
                                    className="searchToggleButton"
                                    variant={(this.props.filters.meals.find(meal=>meal==='HB')?'contained':'outlined')}
                                    color='primary'
                                    onClick={e=>this.toggleMealCode('HB')}
                                >
                                    {t('package.mealPlans.halfBoard')}
                                </Button>
                                </Grid>

                                <Grid item  xs={4}>
                                <Button
                                    className="searchToggleButton"
                                    variant={(this.props.filters.meals.find(meal=>meal==='FB')?'contained':'outlined')}
                                    color='primary'
                                    onClick={e=>this.toggleMealCode('FB')}
                                >
                                    {t('package.mealPlans.fullBoard')}
                                </Button>
                                </Grid>
*/}
                                <Grid item  xs={4}>
                                <Button
                                    className="searchToggleButton"
                                    variant={(this.props.filters.meals.find(meal=>meal==='AI')?'contained':'outlined')}
                                    color='primary'
                                    onClick={e=>this.props.toggleMealCode('AI')}
                                >
                                    <strong>​{t('search.steps.meals.allInclusive')}​</strong>
                                </Button>
                                </Grid>
                            </Grid>

                            <Box m={2}></Box>      

                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <h1>​{t('search.steps.hotelFeatures.title')}​</h1> 
                                    {/*<div className='notification mt-1'>
                                        <WbIncandescentIcon 
                                            className='icon'
                                        />{t('search.steps.destination.tip')}
                                    </div>*/}
                                </Grid>

                        
                                <Grid item xs={4} className="NarrowButton">
                                    <Button 
                                        onClick={e=>this.props.toggleResetSpecialHotel()}
                                        className="searchToggleButton"
                                        color='primary'
                                        variant={!this.props?.filters?.highlights || this.props?.filters?.highlights=={} || (!this.props?.filters?.highlights?.waterpark && !this.props?.filters?.highlights?.casino && !this.props?.filters?.highlights?.luxury && !this.props?.filters?.highlights?.near_chabad && !this.props?.filters?.highlights?.spa) ?'contained':'outlined'}>{t('search.steps.hotelFeatures.noPreference')}</Button>
                                </Grid>

                                <Grid item xs={4} className="NarrowButton">
                                    <Button 
                                        onClick={e=>this.props.toggleWaterpark()}
                                        className="searchToggleButton"
                                        color='primary'
                                        variant={this.props?.filters?.highlights?.waterpark?'contained':'outlined'}><strong>​{t('search.steps.hotelFeatures.waterpark')}​</strong></Button>
                                </Grid>

                                <Grid item xs={4} className="NarrowButton">
                                    <Button 
                                        onClick={e=>this.props.toggleCasino()}
                                        className="searchToggleButton"
                                        color='primary'
                                        variant={this.props?.filters?.highlights?.casino?'contained':'outlined'}><strong>​{t('search.steps.hotelFeatures.casino')}​</strong></Button>
                                </Grid>

                                <Grid item xs={4} className="NarrowButton">
                                    <Button 
                                        onClick={e=>this.props.toggleLuxury()}
                                        className="searchToggleButton"
                                        color='primary'
                                        variant={this.props?.filters?.highlights?.luxury?'contained':'outlined'}><strong>​{t('search.steps.hotelFeatures.luxury')}​</strong></Button>
                                </Grid>
                                {currentLang!='ar' ? (
                                <Grid item xs={4} className="NarrowButton">
                                    <Button 
                                        onClick={e=>this.props.toggleNearChabad()}
                                        className="searchToggleButton"
                                        color='primary'
                                        variant={this.props?.filters?.highlights?.near_chabad?'contained':'outlined'}>
                                            <strong>​{t('search.steps.hotelFeatures.nearChabad')}​</strong></Button>
                                </Grid>) : (<></>)}

                                <Grid item xs={4} className="NarrowButton">
                                    <Button 
                                        onClick={e=>this.props.toggleSpa()}
                                        className="searchToggleButton"
                                        color='primary'
                                        variant={this.props?.filters?.highlights?.spa?'contained':'outlined'}>
                                            <strong>​{t('search.steps.hotelFeatures.spa')}​</strong></Button>
                                </Grid>
                                {/*
                                <Grid item xs={4} className="NarrowButton">
                                    <Button
                                        disabled
                                        onClick={e=>this.props.toggleNearChabad()}
                                        className="searchToggleButton"
                                        variant={this.props?.filters?.near_chabad?'contained':'outlined'}>
                                            <span style={{color:'#fff'}}><strong>{t('filters.skiResort.comingSoon')}</strong></span></Button>
                                </Grid>
                                 */}

                            </Grid>                      

                            
                        </div>

                        <a name="step4"></a>
                        <div className={this.props?.step==='3'?'step4':'hidden'} id='step4'>

                            <Grid container spacing={2} className={this.props.filters?.from_date!=='' && this.props.filters?.to_date!=='' && this.props.filters?.dates_type!=='range' ?'hidden':''}>
                                <Grid item xs={12}>
                                    <h1>​{t('search.steps.nights.title')}​</h1> 
                                    {t('search.steps.nights.subtitle')}
                                </Grid>

                                <Grid item xs={2} sm={2}>
                                    <Button
                                        className="searchToggleButton"
                                        variant={this.props.filters?.nights?.length==0?'contained':'outlined'}
                                        color='primary'
                                        onClick={e=>this.props.toggleNights('all')} 
                                    ><strong>​{t('search.steps.nights.all')}​</strong>
                                    </Button>
                                </Grid>

                                <Grid item xs={2} sm={2}>
                                    <Button
                                        className="searchToggleButton"
                                        variant={this.props.filters?.nights?.find(night=>night==='3')?'contained':'outlined'}
                                        color='primary'
                                        onClick={e=>this.props.toggleNights('3')} 
                                    ><strong>3</strong>
                                    {t('search.steps.nights.nightsLabel')}
                                    </Button>
                                </Grid>
                                <Grid item xs={2} sm={2}>
                                    <Button
                                        className="searchToggleButton"
                                        variant={this.props.filters?.nights?.find(night=>night==='4')?'contained':'outlined'}
                                        color='primary'
                                        onClick={e=>this.props.toggleNights('4')} 
                                    ><strong>4</strong>
                                    {t('search.steps.nights.nightsLabel')}
                                    </Button>
                                </Grid>                                        
                                <Grid item xs={2} sm={2}>
                                    <Button
                                        className="searchToggleButton"
                                        variant={this.props.filters?.nights?.find(night=>night==='5')?'contained':'outlined'}
                                        color='primary'
                                        onClick={e=>this.props.toggleNights('5')} 
                                    ><strong>5</strong>
                                    {t('search.steps.nights.nightsLabel')}
                                    </Button>
                                </Grid>
                                <Grid item xs={2} sm={2}>
                                    <Button
                                        className="searchToggleButton"
                                        variant={this.props.filters?.nights?.find(night=>night==='6')?'contained':'outlined'}
                                        color='primary'
                                        onClick={e=>this.props.toggleNights('6')} 
                                    ><strong>6</strong>
                                    {t('search.steps.nights.nightsLabel')}
                                    </Button>
                                </Grid>
                                <Grid item xs={2} sm={2}>
                                    <Button
                                        className="searchToggleButton"
                                        variant={this.props.filters?.nights?.find(night=>night==='7')?'contained':'outlined'}
                                        color='primary'
                                        onClick={e=>this.props.toggleNights('7')} 
                                    ><strong>7</strong>
                                    {t('search.steps.nights.nightsLabel')}
                                    </Button>
                                </Grid>
                            </Grid>
                             

                            <Box m={2}></Box>

                            <Grid container spacing={2} className={this.props.filters?.from_date!=='' && this.props.filters?.to_date!=='' && this.props.filters?.dates_type!=='range' ?'hidden':''}>
                                <Grid item xs={12}>
                                    <h1>​{t('search.steps.weekTime.title')}​</h1> 
                                </Grid>

                                <Grid item xs sm={4}>
                                    <Button
                                        className="searchToggleButton"
                                        variant={(!this.props.filters?.dow || this.props.filters?.dow.length==0 || this.props.filters?.dow.length==7?'contained':'outlined')}
                                        color='primary'
                                        onClick={e=>this.props.toggleDOW('all')}
                                        style={{fontWeight:800}}
                                    >{t('search.steps.weekTime.allWeek')}
                                    </Button>
                                </Grid>
                                <Grid item xs sm={4}>
                                    <Button
                                        className="searchToggleButton"
                                        variant={this.props.filters?.dow && this.props.filters?.dow.length>0 && ['sun','mon','tue','wed','thu'].every(i=>this.props.filters?.dow.includes(i))?'contained':'outlined'}
                                        color='primary'
                                        onClick={e=>this.props.toggleDOW('mon,sun,thu,tue,wed')} >
                                        {t('search.steps.weekTime.midweek')}
                                    </Button>
                                </Grid>
                                <Grid item xs sm={4}>
                                    <Button
                                        className="searchToggleButton"
                                        variant={this.props.filters?.dow && this.props.filters?.dow.length>0 && ['fri','sat'].every(i=>this.props.filters.dow.includes(i))?'contained':'outlined'}
                                        color='primary'
                                        onClick={e=>this.props.toggleDOW('fri,sat')} 
                                    >{t('search.steps.weekTime.weekends')}
                                    </Button>
                                </Grid>                        
                            </Grid>

                            <Box m={2}></Box>
                            
                            
{/*                           
                            <Box m={2}></Box>

                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <h1>{t('filters.hotelServices.title')}</h1>
                                    {t('filters.hotelServices.description')}
                                </Grid>

                                <Grid item  xs={4}>
                                <Button
                                    className="searchToggleButton"
                                    variant={(!this.props?.filters?.waterpark&&!this.props?.filters?.casino&&!this.props?.filters?.kosher?'contained':'outlined')}
                                    color='primary'
                                    onClick={e=>this.props.toggleResetSpecialHotel()}
                                    style={{fontWeight:800}}>
                                        <span style={{fontSize:'.8em'}}>{t('filters.hotelServices.noPreference')}</span>
                                </Button>
                                </Grid>

                                <Grid item xs sm={4}>
                                <Button
                                    className="searchToggleButton"
                                    variant={this.props?.filters?.waterpark?'contained':'outlined'}
                                    color='primary'
                                    onClick={e=>this.props.toggleWaterpark()}
                                    style={{padding:'.5em'}}>
                                        <strong><span style={{fontSize:'.8em'}}>{t('filters.hotelServices.waterPark')}</span></strong>
                                </Button>
                                </Grid>

                                <Grid item xs sm={4}>
                                <Button
                                    disabled
                                    className="searchToggleButton"
                                    variant={this.props?.filters?.casino?'contained':'outlined'}
                                    color='primary'
                                    onClick={e=>this.props.toggleCasino()}
                                    style={{padding:'.5em'}}>
                                        <strong><span style={{fontSize:'.8em', color:'#bbb'}}>{t('filters.hotelServices.casino.comingSoon')}</span></strong>
                                </Button>
                                </Grid>

                                <Grid item xs sm={3}>
                                <Button
                                    disabled
                                    className="searchToggleButton"
                                    variant={this.props?.filters?.kosher?'contained':'outlined'}
                                    color='primary'
                                    onClick={e=>this.props.toggleKosher()}
                                    style={{padding:'.5em'}}>
                                        <strong><span style={{fontSize:'.8em',color:'#bbb'}}>{t('filters.hotelServices.kosher.comingSoon')}</span></strong>
                                </Button>
                                </Grid>

                            </Grid>
*/}
                            <Box m={2}></Box>

                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <h1>​{t('search.steps.destination.question')}​</h1> 
                                    <div className='notification mt-1'>
                                        <WbIncandescentIcon 
                                            className='icon'
                                        />{t('search.steps.destination.tip')}
                                    </div>
                                </Grid>
                                <Grid  item xs sm={3} lg={6}>
                                    <Button 
                                    className="searchToggleButton"
                                    onClick={e=>this.props.resetDestinations(e)}
                                    style={{padding:'.5em'}}
                                    color='primary'
                                    variant={(!this.props?.filters?.destinations || this.props?.filters?.destinations.length==0?'contained':'outlined')}><strong>​{t('search.steps.destination.cheapest')}​</strong></Button></Grid>
                                 <Grid  item xs sm={3} lg={6}>
                                    <Button 
                                    className="searchToggleButton"
                                    onClick={e=>this.props.toggleDestinations(e)}
                                    style={{padding:'.5em'}}
                                    color='primary'
                                    variant={this.props?.filters?.destinations && this.props?.filters?.destinations.length >0?'contained':'outlined'}><strong>
                                        {
                                            this.props?.filters?.destinations && this.props?.filters?.destinations.length > 0?
                                                    t('search.steps.destination.showSelected', { count: this.props?.filters?.destinations.length })
                                                :
                                                    t('search.steps.destination.selectDestination')
                                        }
                                    </strong></Button>
                                </Grid>
                            </Grid>

                            <Box m={2}></Box>

                            

                            <Grid container spacing={2} 
                                className={
                                    // if
                                    (
                                        // Check if either the July & August month buttons were selected
                                        (   
                                            this.props?.filters?.months?.find(month=>month.includes('-07')) || 
                                            this.props?.filters?.months?.find(month=>month.includes('-08')) 
                                        ) &&  // But none of the other months were selected
                                            !this.props?.filters?.months?.find(month=>month.includes('-01')) &&  
                                            !this.props?.filters?.months?.find(month=>month.includes('-02')) && 
                                            !this.props?.filters?.months?.find(month=>month.includes('-03')) && 
                                            !this.props?.filters?.months?.find(month=>month.includes('-04')) && 
                                            !this.props?.filters?.months?.find(month=>month.includes('-05')) && 
                                            !this.props?.filters?.months?.find(month=>month.includes('-06')) && 
                                            !this.props?.filters?.months?.find(month=>month.includes('-09')) && 
                                            !this.props?.filters?.months?.find(month=>month.includes('-10')) && 
                                            !this.props?.filters?.months?.find(month=>month.includes('-11')) && 
                                            !this.props?.filters?.months?.find(month=>month.includes('-12')) 
                                    ) || // OR
                                    (
                                        // If the dates range selected isbetween July & August
                                        this.props.filters.from && 
                                        this.props.filters.from.getMonth()>=6 && 
                                        this.props.filters.from.getMonth()<=7 && 
                                        this.props.filters.to && 
                                        this.props.filters.to.getMonth()>=6 && 
                                        this.props.filters.to.getMonth()<=7 
                                        /*
                                        this.props?.filters?.from && 
                                        this.props?.filters?.from?.split('-')[0]>=6 && 
                                        this.props?.filters?.from?.split('-')[0]<=7 && 
                                        this.props?.filters?.to && 
                                        this.props?.filters?.to?.split('-')[0]>=6 && 
                                        this.props?.filters?.to?.split('-')[0]<=7
                                        */
                                    ) || // OR
                                    (
                                        this.props.filters.holidays.find(holiday=>holiday.includes('school-summer-vacation'))
                                    )
                                    ?
                                    'hidden': // Show pax selection - <<<<< 2023-05-20 we've changed it to hidden by default in any case, because we no longer want to show this option
                                    'hidden'
                                }>
                                <Grid item xs={12}>
                                    <h1>​{t('search.steps.pax.title')}​</h1> 
                                </Grid>
                                <Grid item xs sm={4}>
                                    <Button
                                        className="searchToggleButton pax"
                                        variant={this.props.filters?.adults==2&&this.props.filters?.children==0?'contained':'outlined'}
                                        color='primary'
                                        onClick={e=>this.props.toggleChildren(0)}
                                        startIcon={<PeopleIcon />}
                                    >
                                        <strong>​{t('search.steps.pax.couple')}​</strong>
                                    </Button>
                                    </Grid>

                                    <Grid item xs sm={3}>
                                    <Button
                                        className="searchToggleButton pax"
                                        variant={this.props.filters?.adults==2&&this.props.filters?.children==2?'contained':'outlined'}
                                        color='primary'
                                        onClick={e=>this.props.toggleChildren(2)}
                                        startIcon={<FamilyRestroomIcon />}
                                    >
                                        {t('search.steps.pax.coupleWithTwo')}
                                    </Button>
                                    </Grid>

                                    <Grid item xs sm={3}>
                                    <Button
                                        className="searchToggleButton pax"
                                        variant={this.props.filters?.adults==2&&this.props.filters?.children==3?'contained':'outlined'}
                                        color='primary'
                                        onClick={e=>this.props.toggleChildren(3)}
                                        startIcon={<FamilyRestroomIcon />}
                                    >
                                        {t('search.steps.pax.coupleWithThree')}
                                    </Button>
                                    </Grid>
                            </Grid>
                        </div>
                        
                        <a name="step5"></a>
                        <div className={this.props?.step==='4'?'step5':'hidden'} id='step5'>        
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <h1>​{t('search.steps.whereToVacation.question')}​</h1> 
                                <div className='notification search-destination-notification'>
                                <WbIncandescentIcon
                                    className='icon'
                                />{t('search.steps.whereToVacation.tip')}
                            </div>
                                
                            </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                            <List>
                                <ListItem key={'all'} role={undefined} dense button >
                                <FormControlLabel
                                    className="list_all_items"
                                    value='all'
                                    control={<Checkbox color="primary" />}
                                    //label={`כל היעדים (מומלץ)`}
                                    label={<><Typography className='label_select_all_cities'>​{t('search.steps.whereToVacation.allDestinations')}​</Typography><Typography className='label_select_all_cities_recommended'>​{t('search.steps.whereToVacation.recommended')}</Typography></>}
                                    labelPlacement="start"
                                    onClick={e=>this.props.toggleDestinationSelection(e, 'all')}
                                    checked={this.props.filters?.destinations.length==0}
                                    />
                                </ListItem>
                                <Divider variant="inset" component="li" />
                                {
                                    (
                                        this.props?.all_destinations&&this.props?.all_destinations?.length>0)?this.props?.all_destinations?.map((value,index) => {
                                            const labelId = `checkbox-list-label-${value}`;
                                            return (
                                                <div key={value+index} >
                                                    <ListItem role={undefined} dense button >
                                                        <FormControlLabel
                                                            value={value.city_id}
                                                            onClick={e=>this.props.toggleDestinationSelection(e, value.city_id+'')}
                                                            control={<Checkbox color="primary" />}
                                                            label={<><Typography className='label_city_name'>{value.city_name}</Typography>, {value.country_name}</>}
                                                            labelPlacement="start"
                                                            tabIndex={-1}
                                                            //inputProps={{ 'aria-labelledby': labelId }}
                                                            checked={this.props.filters?.destinations.includes(value.city_id+'')}
                                                            />
                                                    </ListItem>
                                                    <Divider variant="inset" component="li" />
                                                </div>
                                            );
                                        }
                                    ):
                                    (<center><CircularProgress /></center>)
                                }
                            </List>
                            </Grid>
                        </Grid>
                        </div>
                    </div>                                  

                </DialogContent>
                <DialogActions>
                    <Button onClick={e=>this.props.handleNext(e)} className='submit-button'>
                        {this.props.step==='3' && !this.props.filters?.window?.next_step_close===true?(t('search.showResults')):(t('search.continue'))}
                    </Button>
                    
                </DialogActions>
            </Dialog>
            
        </>
        )
    }
}

/**
 * Get the names of the next N months with their year.
 * 
 * @param {*} startDate 
 * @param {*} endDate 
 * @param {*} skipMonths 
 * @returns 
 */
function getNextNMonthNamesWithYear(startDate, endDate, skipMonths=[]) {

    // Set fromDate & toDate to the date of the first date of the relative month
    const fromDate = new Date(startDate.getFullYear(), startDate.getMonth(), 1);
    const toDate = new Date(endDate.getFullYear(), endDate.getMonth() , 1);

    //console.log(fromDate, toDate, skipMonths);
    
    const res = [];

    const monthNames = [
        i18n.t('common.months.january'),
        i18n.t('common.months.february'),
        i18n.t('common.months.march'),
        i18n.t('common.months.april'),
        i18n.t('common.months.may'),
        i18n.t('common.months.june'),
        i18n.t('common.months.july'),
        i18n.t('common.months.august'),
        i18n.t('common.months.september'),
        i18n.t('common.months.october'),
        i18n.t('common.months.november'),
        i18n.t('common.months.december')
    ];

    let fromDateCopy = new Date(fromDate); // Copy date object (so it won't modify original date by reference)

    while (fromDateCopy <= toDate) {
        const month = fromDateCopy.getMonth();
        const monthName = monthNames[month];
        const year = fromDateCopy.getFullYear();

        if (!skipMonths || skipMonths.length==0 || (skipMonths.length>0 && !(skipMonths.find(m=>((m.split('-')[1]-1)==month && m.split('-')[0]==year))))) {
            res.push({ 
                'name'  : monthName + ' ' + year, 
                'value' : year + '-' + ('0' + (month+1)).slice(-2),
                'month' : month
            });
        }
        fromDateCopy.setMonth(month + 1);
    }    

    //console.log(res)
    // Calculate the number of cells per row
    let cellsPerRow = 3;
    if ((res.length >= 6 && res.length < 8) || res.length > 8) 
        cellsPerRow = 4;

    // make sure the returned items in the array can always be divided by 4 (if not, add empty ones)
    const emptyCells = cellsPerRow-(res.length+1)%cellsPerRow;
 
    if (emptyCells!=cellsPerRow && emptyCells>0)
        for (var i=0 ; i<emptyCells ; i++)
            res.push({
                'name'  : null,
                'value' : null,
                'month' : null
            });

    return res;
}






export default withTranslation()(SearchWizard)